export default __webpack_public_path__ + "static/2020-scheda-tecnica-d67a48d22d4b4a26f5201615726f1f24.pdf";